import styled from 'styled-components'

export const Container = styled.div`
  /* margin-top:100px; */
  width:100%;
  margin-bottom:100px;
  padding: 1rem;
`

export const TituloGuia = styled.p`
  font-size:24px;
  position:relative;
  top:24px;
  font-weight:800
`